import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs, doc, updateDoc, getDoc } from 'firebase/firestore';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoDocumentTextOutline, IoLogoWhatsapp, IoGlobeOutline, IoLogoFacebook, IoLogoInstagram, IoLogoTwitter, IoLogoTiktok, IoWarningOutline } from 'react-icons/io5';

import './SuperuserValidacionScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';

function SuperuserValidacionScreen() {
    const navigate = useNavigate();
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSolicitudes();
    }, []);

    const fetchSolicitudes = async () => {
        setLoading(true);
        try {
            // Buscar proveedores:
            // 1. Residentes: 'aprobado_admin' (listo para superuser) O 'en_revision' (pendiente de admin, pero visible para superuser)
            // 2. Externos: 'en_revision_superuser'
            const q1 = query(collection(db, "market_proveedores"), where("estatus", "in", ["aprobado_admin", "en_revision"]));
            const q2 = query(collection(db, "market_proveedores"), where("estatus", "==", "en_revision_superuser"));

            const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);

            // Procesar Residentes (snap1)
            const docs1 = await Promise.all(snap1.docs.map(async (d) => {
                const data = d.data();
                let usuarioInfo = { condominioId: 'Desconocido', isMoroso: false };

                if (data.usuarioId) {
                    try {
                        const userDoc = await getDoc(doc(db, "usuarios", data.usuarioId));
                        if (userDoc.exists()) {
                            const uData = userDoc.data();
                            usuarioInfo = {
                                condominioId: uData.condominioId || 'Sin Asignar',
                                isMoroso: uData.isMoroso || false
                            };
                        }
                    } catch (e) {
                        console.error("Error fetching user details", e);
                    }
                }

                return {
                    id: d.id,
                    ...data,
                    tipo: !data.condominioId ? 'Externo' : (data.estatus === 'en_revision' ? 'Residente (Pendiente Admin)' : 'Residente'),
                    ...usuarioInfo
                };
            }));

            const docs2 = snap2.docs.map(d => ({ id: d.id, ...d.data(), tipo: 'Externo', condominioId: 'N/A (Externo)' }));

            setSolicitudes([...docs1, ...docs2]);
        } catch (error) {
            console.error("Error fetching solicitudes:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDecision = async (proveedorId, decision) => {
        let motivo = "";

        if (decision === 'rechazado') {
            motivo = window.prompt("Ingresa el motivo del rechazo (Opcional):");
            if (motivo === null) return; // Cancelado por el usuario
        } else {
            if (!window.confirm(`¿Estás seguro de APROBAR a este proveedor?`)) return;
        }

        try {
            const nuevoEstatus = decision === 'aprobado' ? 'activo' : 'rechazado';
            const proveedorRef = doc(db, "market_proveedores", proveedorId);

            const updateData = {
                estatus: nuevoEstatus
            };

            if (decision === 'rechazado') {
                updateData.motivoRechazo = motivo;
            }

            await updateDoc(proveedorRef, updateData);

            // Si es aprobado, verificar si es residente y vincular el proveedorId a su perfil de usuario
            if (decision === 'aprobado') {
                const provDoc = await getDoc(proveedorRef);
                const provData = provDoc.data();

                if (provData.usuarioId) {
                    const userRef = doc(db, "usuarios", provData.usuarioId);
                    await updateDoc(userRef, {
                        proveedorId: proveedorId
                    });
                }
            }

            alert(`Proveedor ${decision === 'aprobado' ? 'ACTIVADO' : 'RECHAZADO'} exitosamente.`);
            fetchSolicitudes(); // Recargar lista
        } catch (error) {
            console.error("Error updating status:", error);
            alert("Error al actualizar estatus.");
        }
    };

    if (loading) return <div className="loading-container">Cargando solicitudes...</div>;

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/superuser/validacion-proveedores" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="muro-header-stitch" style={{ marginBottom: '20px' }}>
                        <div className="muro-hero-card">
                            <div className="muro-hero-content">
                                <h1>Validación Global</h1>
                                <p>Gestiona y aprueba solicitudes de proveedores externos y residentes en la red global.</p>
                            </div>
                            <IoGlobeOutline className="muro-hero-icon-decor" />
                        </div>
                    </div>

                    <div className="superuser-container" style={{ padding: '20px', paddingTop: '0px', minHeight: 'auto', background: 'transparent' }}>
                        <div style={{ width: '100%' }}>
                            {solicitudes.length === 0 ? (
                                <div className="empty-state">
                                    <h3>Todo al día</h3>
                                    <p>No hay solicitudes pendientes de aprobación final.</p>
                                </div>
                            ) : (
                                <div className="superuser-list">
                                    {solicitudes.map((solicitud) => (
                                        <div key={solicitud.id} className="superuser-card">

                                            {/* Card Header */}
                                            <div className="card-header-row">
                                                <div className="provider-identity">
                                                    <h3>{solicitud.nombrePublico}</h3>
                                                    <div className="badges-row">
                                                        <span className={`sp-badge type`}>{solicitud.tipo}</span>
                                                        <span className="sp-badge condo">{solicitud.condominioId}</span>

                                                        {/* Moroso Badge only for Residents */}
                                                        {solicitud.tipo.includes('Residente') && (
                                                            solicitud.isMoroso ? (
                                                                <span className="sp-badge moroso">
                                                                    <IoWarningOutline /> Moroso
                                                                </span>
                                                            ) : (
                                                                <span className="sp-badge ok">Al Corriente</span>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card Body */}
                                            <div className="card-body">
                                                <div className="provider-desc">
                                                    <span className="category-tag">{solicitud.categoria}</span>
                                                    <p className="desc-text">{solicitud.descripcion}</p>
                                                </div>

                                                <div className="contact-info">
                                                    <p><strong>Contacto:</strong> {solicitud.nombreContacto}</p>
                                                    <p style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-end' }}>
                                                        <IoLogoWhatsapp color="#25D366" /> {solicitud.telefonoWhatsApp}
                                                    </p>

                                                    <div className="social-links">
                                                        {solicitud.sitioWeb && <a href={solicitud.sitioWeb} target="_blank" rel="noopener noreferrer" style={{ color: '#6b7280' }}><IoGlobeOutline size={20} /></a>}
                                                        {solicitud.redesSociales?.facebook && <a href={solicitud.redesSociales.facebook} target="_blank" rel="noopener noreferrer" style={{ color: '#1877F2' }}><IoLogoFacebook size={20} /></a>}
                                                        {solicitud.redesSociales?.instagram && <a href={solicitud.redesSociales.instagram} target="_blank" rel="noopener noreferrer" style={{ color: '#E4405F' }}><IoLogoInstagram size={20} /></a>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card Footer */}
                                            <div className="card-footer-row">
                                                <div className="docs-links">
                                                    {solicitud.documentos?.constanciaFiscalUrl && (
                                                        <a href={solicitud.documentos.constanciaFiscalUrl} target="_blank" rel="noopener noreferrer" className="doc-link">
                                                            <IoDocumentTextOutline /> Constancia Fiscal
                                                        </a>
                                                    )}
                                                    {solicitud.documentos?.identificacionOficialUrl && (
                                                        <a href={solicitud.documentos.identificacionOficialUrl} target="_blank" rel="noopener noreferrer" className="doc-link">
                                                            <IoDocumentTextOutline /> INE / ID
                                                        </a>
                                                    )}
                                                </div>

                                                <div className="action-buttons">
                                                    <button
                                                        onClick={() => handleDecision(solicitud.id, 'rechazado')}
                                                        className="sp-btn reject"
                                                        title="Rechazar"
                                                    >
                                                        <IoCloseCircleOutline size={24} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleDecision(solicitud.id, 'aprobado')}
                                                        className="sp-btn approve"
                                                        title="Aprobar Final"
                                                    >
                                                        <IoCheckmarkCircleOutline size={24} />
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
                <KondoBottomNav activeRoute="/superuser/validacion-proveedores" />
            </main>
        </div>
    );
}

export default SuperuserValidacionScreen;
